import React from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import BBBreadcrumbs from '../BodyBlocks/BBBreadcrumbs';
import BBHeading from '../BodyBlocks/Text/BBHeading';
import RelatedCategories from './RelatedCategories';

import styles from './index.module.scss';
import FormattedText from '../../01_atoms/FormattedText';

const ResourcePageTopInfo = ({
  breadcrumbs = null,
  title,
  metaInfo = null,
  relatedCategories = [],
  type,
  icon,
  showBackButton = false,
}) => {
  const router = useRouter();

  const handleBack = () => {
    router.back();
  };
  return (
    <>
      <div className={styles['resource-breadcrumbs']}>
        <BBBreadcrumbs breadcrumbs={breadcrumbs} showOnMobile={false} inContainer={false} />
      </div>

      {showBackButton && (
        <div className={styles['resource-back']}>
          <div className="container">
            <div
              className={`${styles['resource-back-button']} analytics-resource-page-back-button`}
              tabIndex="0"
              onClick={handleBack}
              onKeyPress={handleBack}
            >
              Back
            </div>
          </div>
        </div>
      )}

      <div className="container">
        <div className={styles['resource-type']}>
          <img src={icon} className={styles['resource-type-icon']} alt="" width={18} height={18} />
          {type}
        </div>
      </div>
      <BBHeading
        title={title}
        Tag="h1"
        className={styles['resource-title']}
        classNameWrapper={styles['resource-title-wrapper']}
      />
      {metaInfo && !!metaInfo.length && (
        <div className={`${styles['resource-meta-info']} container`}>
          {metaInfo.map((item, index) => (
            <div key={item.title} className={styles['resource-meta-info-item']}>
              <strong>{item.title}: </strong>
              <FormattedText
                className={styles['resource-meta-info-item-value']}
                text={item.value}
              />
              {index + 1 !== metaInfo.length && (
                <div className={styles['resource-meta-info-separator']}>|</div>
              )}
            </div>
          ))}
        </div>
      )}

      {relatedCategories && !!relatedCategories.length && (
        <div className={`${styles['resource-categories']} container`}>
          Related:
          <RelatedCategories relatedCategories={relatedCategories} />
        </div>
      )}
    </>
  );
};

ResourcePageTopInfo.propTypes = {
  breadcrumbs: PropTypes.shape({
    links: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        nextLink: PropTypes.shape({
          href: PropTypes.string,
          as: PropTypes.string,
        }),
      }),
    ),
  }),
  metaInfo: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      value: PropTypes.string,
    }),
  ),
  relatedCategories: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      url: PropTypes.string,
    }),
  ),
  title: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  showBackButton: PropTypes.bool,
};

export default ResourcePageTopInfo;
